import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAuthor: false,
    token: "test",
    language: "uk",
    // elementData: { id: 0, title: "", parentId: 0, sort: 0 },
    iFrameId: [],
    isShowIframes: false,
};

export const statusSlice = createSlice({
    name: "status",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.isAuthor = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        // setElementData: (state, action) => {
        //     state.language = action.payload;
        // },
        setIframeId: (state, action) => {
            state.iFrameId = action.payload;
        },
        setIsShowIFrame: (state, action) => {
            state.isShowIframes = action.payload;
        },
    },
});

export const { setStatus, setToken, setLanguage, setElementData, setIframeId, setIsShowIFrame } = statusSlice.actions;

export default statusSlice.reducer;
